/** Traduzioni inglesi: l'italiano, com'è scritto in `t()`, e l'inglese. */
export const EN_COMUNE: Record<string, string> = {
  // La navigazione e le famiglie del registro (costanti, tradotte dove si mostrano)
  'Server': 'Servers',
  'Istanze': 'Instances',
  'Catalogo': 'Catalog',
  'Backup': 'Backups',
  'Continuità': 'Continuity',
  'Traslochi': 'Migrations',
  'Indirizzi IP': 'IP addresses',
  'Attività': 'Activity',
  'Persone': 'People',
  'Registro': 'Audit log',
  'Assistenti': 'Assistants',
  'Impostazioni': 'Settings',
  'Organizzazione': 'Organization',
  // Lo shell, l'ingresso, le organizzazioni
  'Connessione a Molo': 'Connecting to Molo',
  'Connessione a Molo…': 'Connecting to Molo…',
  'Altro': 'More',
  'Lingua del pannello': 'Panel language',
  'Esco…': 'Signing out…',
  'Esci': 'Sign out',
  '+ Nuova organizzazione': '+ New organization',
  'Nuova organizzazione': 'New organization',
  "Un'azienda a sé: server, istanze, backup e persone sono suoi e non si mescolano con le altre. Chi la crea ne diventa owner.": 'A company of its own: its servers, instances, backups and people don’t mix with the others. Whoever creates it becomes its owner.',
  'Annulla': 'Cancel',
  'Crea': 'Create',
  'Creo…': 'Creating…',
  'Non è stata creata': 'It wasn’t created',
  'Nome breve': 'Short name',
  'Solo minuscole, cifre e trattini, es. «blendx». Compare nei link e non si cambia più.': 'Lowercase letters, digits and hyphens only, e.g. “blendx”. It appears in links and can’t be changed later.',
  'Solo minuscole, cifre e trattini, es. «meshble». Compare nei link e non si cambia più.': 'Lowercase letters, digits and hyphens only, e.g. “meshble”. It appears in links and can’t be changed later.',
  'Stai guardando come {email}': 'You’re viewing as {email}',
  'Sola lettura. Finisce da sé alle {ora}.': 'Read-only. It ends by itself at {ora}.',
  'Torna te stesso': 'Stop impersonating',
  'I tuoi server Odoo, gestiti da Meshble.': 'Your Odoo servers, managed by Meshble.',
  "L'accesso non è configurato": 'Sign-in is not configured',
  'Chi gestisce Molo deve collegare un fornitore di identità (OIDC) prima che si possa entrare.': 'Whoever runs Molo must connect an identity provider (OIDC) before anyone can sign in.',
  'Entra con Google Workspace': 'Sign in with Google Workspace',
  'Solo indirizzi {domini}': 'Only {domini} addresses',
  'Email': 'Email',
  'tu@meshble.com': 'you@meshble.com',
  'Accesso di sviluppo, senza password.': 'Development sign-in, no password.',
  'Ambiente di sviluppo: basta l’email, senza password.': 'Development environment: just the email, no password.',
  'Accesso non riuscito': 'Sign-in failed',
  'Entro…': 'Signing in…',
  'Entra': 'Sign in',
  'Nessuna organizzazione': 'No organization',
  'Crea organizzazione': 'Create organization',
  'Sei dentro come {email}, ma non fai ancora parte di nessuna organizzazione. Chiedi a chi la amministra di invitarti, oppure creane una tua.': 'You’re signed in as {email}, but you’re not part of any organization yet. Ask an organization’s admin to invite you, or create your own.',
  'Non fai ancora parte di nessuna organizzazione. Chiedi a chi la amministra di invitarti, oppure creane una tua.': 'You’re not part of any organization yet. Ask an organization’s admin to invite you, or create your own.',
  'Non creata': 'Not created',
  // Il marchio e i componenti del design (StatusChip, StepProgress, LogStream, NavRail)
  'Passo {n} di {totale}': 'Step {n} of {totale}',
  'Passo {n}': 'Step {n}',
  'In attesa': 'Waiting',
  'Carico…': 'Loading…',
  'Avanzamento': 'Progress',
  'In attesa delle prime righe…': 'Waiting for the first lines…',
  'Navigazione principale': 'Main navigation',
  'In creazione': 'Creating',
  'In preparazione': 'Preparing',
  'In attesa di SSH': 'Waiting for SSH',
  'In adozione': 'Adopting',
  'Installazione stack': 'Installing stack',
  'Verifica': 'Verify',
  'Pronto': 'Ready',
  'Fallito': 'Failed',
  'In dismissione': 'Decommissioning',
  'Dismesso': 'Decommissioned',
  // Gli errori
  'errore {status}': 'error {status}',
  'Questa pagina non esiste': 'This page doesn’t exist',
  'Vai ai server': 'Go to servers',
  "L'indirizzo non corrisponde a nessuna schermata. Può essere un link vecchio, o un identificativo copiato a metà.": 'The address doesn’t match any screen. It may be an old link, or an ID copied only in part.',
  'Questa schermata ha avuto un problema': 'This screen ran into a problem',
  'Riprova': 'Retry',
  'Ricarica': 'Reload',
  'Nessun dettaglio disponibile.': 'No details available.',
  // I titoli dei job (internal/jobs/titoli.json): seguiti dal nome del bersaglio
  'Installazione del server': 'Installing server',
  'Scollegamento del server': 'Disconnecting server',
  'Creazione dell’istanza': 'Creating instance',
  'Rimozione dell’istanza': 'Removing instance',
  'Ripristino da backup': 'Restore from backup',
  'Backup dell’istanza': 'Backing up instance',
  'Avvio dell’istanza': 'Starting instance',
  'Arresto dell’istanza': 'Stopping instance',
  'Riavvio dell’istanza': 'Restarting instance',
  'Riconfigurazione dell’istanza': 'Reconfiguring instance',
  'Aggiornamento di Odoo su': 'Updating Odoo on',
  'Copia di prova di': 'Staging copy of',
  'Ricarico della copia': 'Reloading staging copy',
  'Ripristino in produzione di': 'Production restore of',
  'Prova di ripristino di': 'Restore test of',
  'Collegamento del dominio': 'Connecting domain',
  'Rimozione del dominio': 'Removing domain',
  'Ripristino d’emergenza': 'Disaster recovery',
  'Collegamento della macchina CloudPepper': 'Connecting CloudPepper machine',
  'Inventario della macchina CloudPepper': 'Inventory of CloudPepper machine',
  'Scollegamento della macchina CloudPepper': 'Disconnecting CloudPepper machine',
  'Prova di trasloco': 'Migration rehearsal',
  'Trasloco': 'Migration',
  'Ritorno su CloudPepper': 'Back to CloudPepper',
  'Import da CloudPepper di': 'Import from CloudPepper of',
  'Pulizia dei backup vecchi': 'Cleaning up old backups',
  'Verifica di un backup': 'Verifying a backup',
  'Pianificazione dei backup': 'Scheduling backups',
  'Backup dei certificati dei server': 'Backing up server certificates',
  'Giro delle prove di ripristino': 'Restore test round',
  'Pulizia delle metriche': 'Cleaning up metrics',
  'Controllo di funzionamento': 'Health check',
  // Com'è andato un job
  'Il server è pronto: ci puoi creare un’istanza.': 'The server is ready: you can create an instance on it.',
  'Il server non è più gestito da Molo: le sue istanze non compaiono più e i loro indirizzi sono stati tolti.': 'The server is no longer managed by Molo: its instances no longer appear and their addresses have been removed.',
  'L’istanza è attiva.': 'The instance is up.',
  'L’istanza non c’è più.': 'The instance is gone.',
  'La copia è attiva, accanto all’originale.': 'The copy is up, next to the original.',
  'Il backup è al sicuro nella destinazione.': 'The backup is safe in the destination.',
  'L’istanza è attiva e risponde.': 'The instance is up and responding.',
  'L’istanza è ferma. Resta ferma anche se il server si riavvia.': 'The instance is stopped. It stays stopped even if the server reboots.',
  'L’istanza è di nuovo attiva e risponde.': 'The instance is up again and responding.',
  'La nuova configurazione è attiva: Odoo è ripartito e risponde.': 'The new configuration is active: Odoo restarted and is responding.',
  'Odoo è aggiornato e l’istanza risponde.': 'Odoo is updated and the instance is responding.',
  'La copia di prova è pronta e risponde.': 'The staging copy is ready and responding.',
  'La copia ha di nuovo i dati e il codice della produzione.': 'The copy has the production data and code again.',
  'I dati sono quelli del backup: Odoo è ripartito e risponde. Quelli di prima restano nel backup di sicurezza.': 'The data is now the backup’s: Odoo restarted and is responding. The previous data stays in the safety backup.',
  'Il backup si ricarica: utenti, moduli e allegati ci sono tutti.': 'The backup restores: users, modules and attachments are all there.',
  'Il dominio risponde in HTTPS con il suo certificato.': 'The domain responds over HTTPS with its certificate.',
  'Il dominio non è più collegato.': 'The domain is no longer connected.',
  'La corsa è finita: la scheda dei tempi è in Continuità.': 'The run is over: the timing sheet is in Continuity.',
  'Molo è entrato nella macchina e ne ha letto le istanze: le trovi in Traslochi.': 'Molo got into the machine and read its instances: you’ll find them in Migrations.',
  'L’inventario è aggiornato: le istanze sono in Traslochi.': 'The inventory is up to date: the instances are in Migrations.',
  'Sulla macchina non c’è più niente di Molo.': 'Nothing of Molo is left on the machine.',
  'La prova è pronta: guardala, e il giorno del trasloco premi «Trasloca».': 'The rehearsal is ready: check it, and on migration day press “Migrate”.',
  'L’istanza è su Molo e CloudPepper è spento: adesso gli indirizzi.': 'The instance is on Molo and CloudPepper is off: now the addresses.',
  'L’originale su CloudPepper è di nuovo acceso, e il nome punta di nuovo lì.': 'The original on CloudPepper is on again, and the name points there again.',
  'L’istanza è attiva con i dati di CloudPepper.': 'The instance is up with the CloudPepper data.',
  'I backup vecchi sono stati eliminati.': 'Old backups have been deleted.',
  'Il backup si rilegge correttamente.': 'The backup reads back correctly.',
  'I backup pianificati sono stati accodati.': 'Scheduled backups have been queued.',
  'I certificati di ogni server sono al sicuro nel backup.': 'Every server’s certificates are safe in the backup.',
  'Le prove di ripristino del giorno sono state accodate.': 'Today’s restore tests have been queued.',
  'Le metriche vecchie sono state eliminate.': 'Old metrics have been deleted.',
  'Tutto risponde.': 'Everything is responding.',
  // I passi dei job
  'Aggiornamento del sistema': 'System update',
  'Lingua e orologio': 'Language and clock',
  'Memoria di riserva': 'Swap memory',
  'Regolazione del sistema': 'System tuning',
  'Registro di sistema': 'System log',
  'Aggiornamenti di sicurezza automatici': 'Automatic security updates',
  'Programmi di base': 'Base packages',
  'Caratteri per i PDF': 'Fonts for PDFs',
  'Strumenti per l’interfaccia web': 'Web interface tools',
  'Generatore di PDF': 'PDF generator',
  'Database PostgreSQL': 'PostgreSQL database',
  'Regolazione del database': 'Database tuning',
  'Server web': 'Web server',
  'Strumento per i certificati': 'Certificate tool',
  'Firewall': 'Firewall',
  'Protezione dagli accessi indesiderati': 'Intrusion protection',
  'Accesso sicuro': 'Secure access',
  'Base comune di Odoo': 'Odoo common base',
  'Agente di monitoraggio': 'Monitoring agent',
  'Verifica finale': 'Final check',
  'Strumento di backup': 'Backup tool',
  'Certificato HTTPS': 'HTTPS certificate',
  'Chiusura dell’accesso iniziale': 'Closing initial access',
  'IP fisso': 'Static IP',
  'Cartelle dell’istanza': 'Instance folders',
  'Codice di Odoo': 'Odoo code',
  'Ambiente Python': 'Python environment',
  'Moduli aggiuntivi': 'Add-on modules',
  'Database': 'Database',
  'Configurazione': 'Configuration',
  'Primo avvio di Odoo': 'First Odoo start',
  'Servizio di sistema': 'System service',
  'Indirizzo web': 'Web address',
  'Prova di funzionamento': 'Smoke test',
  'Riavvio con la nuova configurazione': 'Restart with the new configuration',
  'Backup di sicurezza dei dati attuali': 'Safety backup of the current data',
  'Recupero dello snapshot': 'Fetching the snapshot',
  'Sostituzione dei dati e riavvio': 'Replacing the data and restarting',
  'Carico in un database a parte e controlli': 'Loading into a separate database and checks',
  'Ripristino dei dati': 'Data restore',
  'Copia dei dati': 'Data copy',
  'Import dei dati': 'Data import',
  'Riavvio': 'Restarting',
  'Era già fatto': 'Already done',
  'il provider': 'the provider',
  '{chi} sta consegnando l’IP fisso': '{chi} is delivering the static IP',
  'Chiedo la macchina a {chi}': 'Requesting the machine from {chi}',
  '{chi} sta preparando la macchina': '{chi} is preparing the machine',
  'La macchina è accesa, aspetto che risponda': 'The machine is on, waiting for it to respond',
  'Sto raggiungendo la macchina': 'Reaching the machine',
  // Tempi, durate, conteggi
  'adesso': 'just now',
  'un minuto fa': 'a minute ago',
  '{n} minuti fa': '{n} minutes ago',
  'un’ora fa': 'an hour ago',
  '{n} ore fa': '{n} hours ago',
  'ieri': 'yesterday',
  '{n} giorni fa': '{n} days ago',
  '1 giorno': '1 day',
  '{n} giorni': '{n} days',
  'Oggi': 'Today',
  'Ieri': 'Yesterday',
  'Nessuna istanza': 'No instances',
  '1 istanza': '1 instance',
  '{n} istanze': '{n} instances',
  '1 copia': '1 copy',
  '{n} copie': '{n} copies',
  'scaduta': 'expired',
  'ultimo giorno': 'last day',
  '1 passo nuovo': '1 new step',
  '{n} passi nuovi': '{n} new steps',
  '1 istanza con Odoo da aggiornare': '1 instance with Odoo to update',
  '{n} istanze con Odoo da aggiornare': '{n} instances with Odoo to update',
  // Le attività
  'In coda': 'Queued',
  'In corso': 'In progress',
  'Completata': 'Completed',
  'Fallita': 'Failed',
  'Annullata': 'Cancelled',
  'Non riesco a leggere le attività': 'I can’t read the activity',
  'Ancora nessuna attività': 'No activity yet',
  'Qui trovi tutto quello che Molo fa per te e che dura più di un momento: installazioni, nuove istanze, backup, ripristini. Ne comparirà una appena colleghi un server.': 'Here you’ll find everything Molo does for you that takes more than a moment: installations, new instances, backups, restores. The first one will appear as soon as you connect a server.',
  'Stato': 'Status',
  'Avviata': 'Started',
  'Durata': 'Duration',
  'Vai al server': 'Go to server',
  'Vai ai backup': 'Go to backups',
  'Vai alle istanze': 'Go to instances',
  'Vai all’istanza': 'Go to instance',
  'Alle attività': 'Go to activity',
  'Indietro': 'Back',
  'Avviata {quando}': 'Started {quando}',
  'Fatto': 'Done',
  'L’attività è terminata.': 'The task has finished.',
  'Attività annullata': 'Task cancelled',
  'Non è andata a buon fine': 'It didn’t succeed',
  'Si è fermata a «{passo}».': 'It stopped at “{passo}”.',
  'Si è fermata prima di iniziare.': 'It stopped before starting.',
  'Dalla scheda del server puoi riprenderla da lì, senza rifare il resto.': 'From the server page you can resume it from there, without redoing the rest.',
  'Quello che era stato creato è stato tolto: puoi riprovare.': 'What had been created was removed: you can try again.',
  'La copia parziale è stata tolta: l’originale non è stata toccata.': 'The partial copy was removed: the original was not touched.',
  'La configurazione può essere rimasta a metà: guarda il log e rigenerala dalla scheda dell’istanza.': 'The configuration may be half-written: check the log and regenerate it from the instance page.',
  'Se si è fermato prima dello scambio, i dati attuali non sono stati toccati. Se dopo, quelli precedenti sono rimasti sul server con il suffisso _old, e il log dice dove. In ogni caso c’è il backup di sicurezza fatto all’inizio.': 'If it stopped before the swap, the current data was not touched. If after, the previous data is still on the server with the _old suffix, and the log says where. Either way there’s the safety backup taken at the start.',
  'L’istanza non è stata toccata: la prova ricarica il backup in un database a parte. Ma quel backup non si ricarica, e il log dice perché.': 'The instance was not touched: the test loads the backup into a separate database. But that backup doesn’t restore, and the log says why.',
  'Odoo non ha risposto in tempo: il log qui sotto dice perché.': 'Odoo didn’t respond in time: the log below says why.',
  'Ho perso il collegamento': 'Connection lost',
  "L'attività continua sul server anche se qui non arriva più niente. Ricaricando riprendi da dove eri.": 'The task keeps running on the server even if nothing arrives here anymore. Reload to pick up where you were.',
  'Tutti i passi conclusi': 'All steps completed',
  'Ferma a «{passo}»': 'Stopped at “{passo}”',
  'Ferma prima di iniziare': 'Stopped before starting',
  'Sto iniziando': 'Starting',
  'In coda: parte tra pochi secondi.': 'Queued: starts in a few seconds.',
  'Sto salvando database e allegati nella destinazione. Un backup di qualche gigabyte richiede alcuni minuti.': 'Saving the database and attachments to the destination. A backup of a few gigabytes takes a few minutes.',
  'In corso. Ci vuole poco.': 'In progress. It won’t take long.',
  'Carico l’attività…': 'Loading the task…',
  'Terminata senza problemi.': 'Finished without problems.',
  'Terminata.': 'Finished.',
  'Dettagli tecnici': 'Technical details',
  'Identificativo': 'ID',
  'Tipo': 'Type',
  'Conclusa': 'Finished',
  'Le righe compaiono qui appena arrivano.': 'Lines appear here as soon as they arrive.',
  'Questa attività non ha scritto niente nel log.': 'This task wrote nothing to the log.',
  // Il registro
  '{chi} · tramite l’assistente, token {token}': '{chi} · via the assistant, token {token}',
  '{chi} · tramite l’assistente': '{chi} · via the assistant',
  '{chi} · con il token {token}': '{chi} · with token {token}',
  'proprietario': 'owner',
  'amministratore': 'admin',
  'operatore': 'operator',
  'membro': 'member',
  'lettore': 'viewer',
  'limitato': 'limited',
  'una macchina collegata a mano': 'a manually connected machine',
  '«{s}»': '“{s}”',
  'Ha creato il server {n} su {provider}': 'Created server {n} on {provider}',
  'Ha collegato il server {n}': 'Connected server {n}',
  'Ha scollegato il server {n}': 'Disconnected server {n}',
  'Ha riavviato l’installazione del server {n} dal passo {passo}': 'Restarted the installation of server {n} from step {passo}',
  'Ha riavviato l’installazione del server {n}': 'Restarted the installation of server {n}',
  'Il server {n} ha scaricato lo script di avvio': 'Server {n} downloaded the bootstrap script',
  'Ha collegato la macchina CloudPepper {n} come sorgente di trasloco': 'Connected CloudPepper machine {n} as a migration source',
  'La macchina CloudPepper {n} ha scaricato lo script di collegamento': 'CloudPepper machine {n} downloaded the connection script',
  'Molo è entrato nella macchina CloudPepper {n}': 'Molo got into CloudPepper machine {n}',
  'Ha aperto il trasloco di {istanza} da {sorgente} verso {server}': 'Opened the migration of {istanza} from {sorgente} to {server}',
  'Ha corretto il trasloco {n}': 'Edited migration {n}',
  'Ha fatto partire la prova del trasloco {n}': 'Started the rehearsal of migration {n}',
  'Ha fatto partire il trasloco vero di {n}: CloudPepper si spegne': 'Started the real migration of {n}: CloudPepper shuts down',
  'È tornato su CloudPepper con {n}': 'Went back to CloudPepper with {n}',
  'Ha finito gli indirizzi del trasloco {n}': 'Finished the addresses of migration {n}',
  'Ha dato le conferme del trasloco {n}': 'Gave the confirmations for migration {n}',
  'Ha chiuso il trasloco {n}': 'Closed migration {n}',
  'Ha annullato il trasloco {n}': 'Cancelled migration {n}',
  'Ha importato {n} da CloudPepper, senza neutralizzarla': 'Imported {n} from CloudPepper, without neutralizing it',
  'Ha importato {n} da CloudPepper, come prova neutralizzata': 'Imported {n} from CloudPepper, as a neutralized rehearsal',
  'Ha rifatto il segreto del webhook di {url}': 'Regenerated the webhook secret of {url}',
  'Ha dimenticato la macchina CloudPepper {n}, senza toccarla': 'Forgot CloudPepper machine {n}, without touching it',
  'Ha scollegato la macchina CloudPepper {n}': 'Disconnected CloudPepper machine {n}',
  'Ha riavviato il server {n}': 'Rebooted server {n}',
  'L’agente si è registrato da {host}': 'The agent enrolled from {host}',
  'L’agente si è registrato': 'The agent enrolled',
  'Ha assegnato l’IP {ip} al server {server}': 'Assigned IP {ip} to server {server}',
  'Ha liberato l’IP {ip} dal server {server}': 'Released IP {ip} from server {server}',
  'Ha comprato un IP fisso per il server {server}': 'Bought a static IP for server {server}',
  'Ha dichiarato perso il server {n} e ripristinato le istanze su {dest}': 'Declared server {n} lost and restored its instances on {dest}',
  'Ha dichiarato perso il server {n}': 'Declared server {n} lost',
  '(esercitazione)': '(drill)',
  'Ha creato l’istanza {n} con Odoo {major}': 'Created instance {n} with Odoo {major}',
  'Ha creato l’istanza {n}': 'Created instance {n}',
  'Ha rimosso l’istanza {n}': 'Removed instance {n}',
  'Ha avviato l’istanza {n}': 'Started instance {n}',
  'Ha fermato l’istanza {n}': 'Stopped instance {n}',
  'Ha riavviato l’istanza {n}': 'Restarted instance {n}',
  'Ha ripristinato un backup nella nuova istanza {n}': 'Restored a backup into the new instance {n}',
  'Ha ripristinato un backup sull’istanza {n}': 'Restored a backup onto instance {n}',
  'È entrato in {n} come {utente}': 'Signed in to {n} as {utente}',
  'un utente': 'a user',
  'Ha aggiornato il codice di Odoo dell’istanza': 'Updated the instance’s Odoo code',
  'Ha dato a {email} l’accesso SSH a {n} per {ore} ore: {motivo}': 'Gave {email} SSH access to {n} for {ore} hours: {motivo}',
  'Ha dato a {email} l’accesso SSH a {n} per {ore} ore': 'Gave {email} SSH access to {n} for {ore} hours',
  'Ha revocato l’accesso SSH n. {serial} a {n}': 'Revoked SSH access no. {serial} to {n}',
  'Ha installato {installati} e aggiornato tutti i moduli in {n}': 'Installed {installati} and updated all modules in {n}',
  'Ha installato {installati} e aggiornato {aggiornati} in {n}': 'Installed {installati} and updated {aggiornati} in {n}',
  'Ha installato {installati} in {n}': 'Installed {installati} in {n}',
  'Ha aggiornato tutti i moduli in {n}': 'Updated all modules in {n}',
  'Ha aggiornato {aggiornati} in {n}': 'Updated {aggiornati} in {n}',
  'Ha lavorato sui moduli in {n}': 'Worked on the modules in {n}',
  'Ha impostato le librerie Python di {n}: {lista}': 'Set the Python libraries of {n}: {lista}',
  'Ha tolto le librerie Python di {n}': 'Removed the Python libraries of {n}',
  'Ha cambiato la configurazione dell’istanza': 'Changed the instance configuration',
  'Ha attivato Enterprise sull’istanza': 'Enabled Enterprise on the instance',
  'Ha collegato il repository {url} ({ramo})': 'Connected repository {url} ({ramo})',
  'Ha collegato il repository {url}': 'Connected repository {url}',
  'Ha scollegato il repository {url}': 'Disconnected repository {url}',
  'Ha spostato {url} sul ramo {ramo} (era {prima})': 'Moved {url} to branch {ramo} (was {prima})',
  'Ha spostato {url} sul ramo {ramo}': 'Moved {url} to branch {ramo}',
  'Push su {url}: moduli aggiornati': 'Push to {url}: modules updated',
  'Ha creato lo staging {n} da {da}': 'Created staging {n} from {da}',
  'Ha creato lo staging {n}': 'Created staging {n}',
  'Ha aggiornato lo staging con i dati e il codice di produzione': 'Refreshed staging with production data and code',
  'Ha collegato il dominio {dominio}': 'Connected domain {dominio}',
  'Ha scollegato il dominio {dominio}': 'Disconnected domain {dominio}',
  'Ha ritentato il certificato di {dominio}': 'Retried the certificate for {dominio}',
  'Ha fatto un backup dell’istanza {n}': 'Backed up instance {n}',
  'Ha provato il ripristino dell’istanza {n}': 'Tested the restore of instance {n}',
  'Ha scaricato un backup ({db})': 'Downloaded a backup ({db})',
  'Ha scaricato un backup': 'Downloaded a backup',
  'Ha invitato {email} come {ruolo}': 'Invited {email} as {ruolo}',
  'Ha annullato l’invito a {email}': 'Cancelled the invitation to {email}',
  'Ha accettato l’invito ed è entrato come {ruolo}': 'Accepted the invitation and joined as {ruolo}',
  'Ha tolto una persona dall’organizzazione': 'Removed a person from the organization',
  'Ha cambiato un ruolo: da {prima} a {dopo}': 'Changed a role: from {prima} to {dopo}',
  'Ha cambiato un ruolo': 'Changed a role',
  'Ha concesso un accesso a una singola risorsa ({ruolo})': 'Granted access to a single resource ({ruolo})',
  'Ha concesso un accesso a una singola risorsa': 'Granted access to a single resource',
  'Ha revocato un accesso a una singola risorsa': 'Revoked access to a single resource',
  'Ha creato il token API {nome}': 'Created API token {nome}',
  'Ha revocato il token API {nome}': 'Revoked API token {nome}',
  'Ha iniziato a guardare con gli occhi di un altro utente': 'Started viewing as another user',
  'Ha smesso di guardare con gli occhi di un altro utente': 'Stopped viewing as another user',
  'Ha creato l’organizzazione {n}': 'Created organization {n}',
  'Ha rinominato l’organizzazione in {nome}': 'Renamed the organization to {nome}',
  'Ha acceso gli assistenti': 'Turned on assistants',
  'Ha collegato l’assistente {client}': 'Connected assistant {client}',
  'Ha revocato il collegamento di {client}': 'Revoked the connection of {client}',
  'Ha spento gli assistenti': 'Turned off assistants',
  'Ha acceso per gli assistenti {tool}': 'Turned on {tool} for assistants',
  'Ha spento per gli assistenti {tool}': 'Turned off {tool} for assistants',
  'Ha concesso agli admin, per gli assistenti, {tool}': 'Granted admins {tool} for assistants',
  'Ha tolto agli admin, per gli assistenti, {tool}': 'Removed {tool} from admins for assistants',
  'Ha collegato il dominio delle istanze {dominio}': 'Connected the instance domain {dominio}',
  'Ha scollegato il dominio delle istanze': 'Disconnected the instance domain',
  'Ha collegato la credenziale Enterprise': 'Connected the Enterprise credential',
  'Ha scollegato la credenziale Enterprise': 'Disconnected the Enterprise credential',
  'Ha cambiato gli obiettivi di continuità (RTO {rto} min, RPO {rpo} min)': 'Changed the continuity targets (RTO {rto} min, RPO {rpo} min)',
  'Ha cambiato gli obiettivi di continuità': 'Changed the continuity targets',
  'Ha collegato il progetto {nome} su {provider}': 'Connected project {nome} on {provider}',
  'Ha collegato il progetto {nome}': 'Connected project {nome}',
  'Ha scollegato il progetto {nome}': 'Disconnected project {nome}',
  'Ha aggiornato le chiavi del progetto {nome}': 'Updated the keys of project {nome}',
  'Ha aggiunto il recapito {nome} per gli avvisi': 'Added the alert contact {nome}',
  'Ha tolto il recapito {nome} degli avvisi': 'Removed the alert contact {nome}',
  'questo server': 'this server',
  'questa istanza': 'this instance',
  'questo dominio': 'this domain',
  'questo backup': 'this backup',
  'questa persona': 'this person',
  'l’organizzazione': 'the organization',
  'questo progetto': 'this project',
  'questo invito': 'this invitation',
  'questo utente': 'this user',
  'questa risorsa': 'this resource',
  'Cosa': 'What',
  'Tutto': 'Everything',
  'Chi': 'Who',
  'Chiunque': 'Anyone',
  'Solo {cosa}: «{nome}»': 'Only {cosa}: “{nome}”',
  'Solo {cosa}': 'Only {cosa}',
  'Tutto il registro': 'Whole audit log',
  'Le righe che la riguardano, dalla più recente.': 'The entries about it, newest first.',
  'Non riesco a leggere il registro': 'I can’t read the audit log',
  'Serve il permesso di lettura del registro, che non è di tutti.': 'It takes permission to read the audit log, which not everyone has.',
  'Niente con questi filtri.': 'Nothing with these filters.',
  'Ancora niente da raccontare.': 'Nothing to tell yet.',
  'Mostra le righe prima': 'Show earlier entries',
  'Come si legge': 'How to read it',
  'Le righe sono in ordine dal più recente. Ognuna è stata scritta nella stessa transazione dell’operazione che descrive: se l’operazione è avvenuta, la riga c’è. Un clic su una riga apre com’era prima e com’è dopo.': 'Entries are listed newest first. Each one was written in the same transaction as the operation it describes: if the operation happened, the entry is there. Clicking an entry shows what things were like before and after.',
  'Ogni riga porta l’hash della precedente. Un giro notturno ricalcola tutta la catena e segnala da quale punto non torna: togliere o modificare una riga a posteriori si vede. Non protegge da chi può riscrivere l’intero registro, ma da chi vuole togliere la propria riga sì.': 'Each entry carries the hash of the previous one. A nightly run recomputes the whole chain and reports from which point it no longer adds up: removing or changing an entry afterwards shows. It doesn’t protect against someone who can rewrite the whole audit log, but it does against someone who wants to remove their own entry.',
  'Codice': 'Code',
  'Risorsa': 'Resource',
  'Quando': 'When',
  'Riga': 'Entry',
  'Prima': 'Before',
  'Dopo': 'After',
  // Gli inviti
  'in sola lettura': 'read-only',
  'ristretto': 'restricted',
  'Link incompleto': 'Incomplete link',
  "Manca il token dell'invito. Chiedi a chi te l'ha mandato di rigenerarlo: vale una volta sola e non è recuperabile.": 'The invitation token is missing. Ask whoever sent it to regenerate it: it works only once and can’t be recovered.',
  "Carico l'invito": 'Loading the invitation',
  'Invito scaduto o già usato': 'Invitation expired or already used',
  'Invito non valido': 'Invalid invitation',
  "Gli inviti valgono sette giorni e una volta sola. Chiedine un altro a chi amministra l'organizzazione.": 'Invitations are valid for seven days and only once. Ask the organization’s admin for another one.',
  'Invito a {org}': 'Invitation to {org}',
  "Entra per accettare: l'invito ti darà il ruolo di {ruolo}.": 'Sign in to accept: the invitation will give you the {ruolo} role.',
  "Sei stato invitato come {ruolo}. Accettando entri nell'organizzazione e vedi i suoi server, le sue istanze e i suoi backup.": 'You’ve been invited as {ruolo}. By accepting you join the organization and see its servers, instances and backups.',
  'Non accettato': 'Not accepted',
  'Non ora': 'Not now',
  'Accetto…': 'Accepting…',
  'Accetta': 'Accept',
  // Il consenso di un assistente
  'Lettura — guarda, non cambia niente': 'Read — looks, changes nothing',
  'Amministrazione — anche le azioni accese nella pagina «Assistenti»': 'Administration — also the actions turned on in the “Assistants” page',
  'Richiesta incompleta': 'Incomplete request',
  'Questa pagina si apre dall’assistente che chiede di collegarsi, con la sua richiesta nell’indirizzo.': 'This page opens from the assistant asking to connect, with its request in the address.',
  'Carico la richiesta': 'Loading the request',
  'Un assistente chiede di collegarsi a Molo': 'An assistant wants to connect to Molo',
  'Entra per vedere chi è e decidere cosa può fare: il collegamento avrà i tuoi diritti, o meno.': 'Sign in to see who it is and decide what it can do: the connection will have your rights, or fewer.',
  'Non posso collegare questo assistente': 'I can’t connect this assistant',
  'Non ti rimando all’assistente: con una richiesta che non torna, il posto giusto per l’errore è qui.': 'I’m not sending you back to the assistant: with a request that doesn’t add up, the right place for the error is here.',
  '«{client}» chiede di collegarsi a Molo': '“{client}” wants to connect to Molo',
  'Come': 'As',
  'Il codice andrà a': 'The code will go to',
  'Cosa può fare': 'What it can do',
  'Con i tuoi diritti, mai di più, e solo con i tool accesi per l’organizzazione. Il collegamento resta finché l’assistente lo usa (si rinnova ogni trenta giorni) e si revoca dalla pagina «Assistenti». Ogni cosa che fa finisce nel registro con il tuo nome e quello dell’assistente.': 'With your rights, never more, and only with the tools turned on for the organization. The connection lasts as long as the assistant uses it (it renews every thirty days) and is revoked from the “Assistants” page. Everything it does ends up in the audit log with your name and the assistant’s.',
  'Non è andata': 'It didn’t work',
  'Rifiuta': 'Deny',
  'Consenti': 'Allow',
  // Entra in Odoo
  'Entra in Odoo': 'Sign in to Odoo',
  'Come chi vuoi entrare in «{nome}»? Si apre in una scheda nuova, già dentro. Per Odoo è un login normale di quell’utente; nel registro di Molo resta scritto che sei stato tu.': 'Who do you want to sign in to “{nome}” as? It opens in a new tab, already signed in. For Odoo it’s a normal login by that user; Molo’s audit log records that it was you.',
  'Non riesco a leggere gli utenti': 'I can’t read the users',
  'Nessun utente interno attivo in questa istanza.': 'No active internal users in this instance.',
  'Non sono riuscito a entrare': 'I couldn’t sign in',
  'Cerca un utente': 'Search for a user',
  'Cerca per nome o login': 'Search by name or login',
  'Nessun utente corrisponde a «{cerca}».': 'No user matches “{cerca}”.',
  '{login} · ultimo accesso {quando}': '{login} · last login {quando}',
  '{login} · mai entrato': '{login} · never signed in',
  // Parole con due sensi: il senso dopo la barra (vedi lib/lingua.tsx).
  'Verifica|stato': 'Verifying',
};
